import axios from 'axios'
import lstModules from 'common/json/lstModules.json';
var httpURL = lstModules['fees'].url + ":" + lstModules['fees'].port;
var tokenid = localStorage.getItem("tokenid");

function getDiscountListSvc(callBack) {
    // Real API — Harry Sir se confirm hua URL (note: "fee" segment nahi hai path mein).
    axios({
        url: httpURL + "/sms/discount_category/list",
        method: 'POST',
        params: {},
        headers: { 'tokenid': tokenid },
        withCredentials: true
    }).then((response) => {
        callBack(response.data);
    }).catch((error) => {
        console.error(error);
    });
}

function saveDiscountSvc(objDiscount, callBack) {
    // Real API — Harry Sir se confirm hua URL + payload shape
    // (objDiscount { int discountId, String discountLabel, int remarksMandatory }).
    axios({
        url: httpURL + "/sms/discount_category/save",
        method: "POST",
        params: { objDiscount: JSON.stringify(objDiscount) },
        headers: { 'tokenid': tokenid },
        withCredentials: true
    }).then((response) => {
        callBack(response.data);
    }).catch((error) => {
        console.error(error);
    });
}

export { saveDiscountSvc };
export { getDiscountListSvc };
